module.exports = __webpack_public_path__ + "img/bot_02.abf34882.png";